const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20V%C4%B0AYP%C4%B0%C4%B0%20Temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Temizlenecek%20alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

export default function Conversion() {
  return (
    <section className="bg-navy-dark py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="text-center lg:text-left">
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
              FİYAT ALMAK İÇİN<br />
              <span className="text-gold">UZUN UZUN ANLATMANIZA GEREK YOK.</span>
            </h2>

            <p className="text-white/70 text-base md:text-lg leading-relaxed mb-10">
              Temizlenecek alanın kısa videosunu WhatsApp'tan gönderin. Ekibimiz alanı inceleyerek ihtiyaç duyulan çalışma kapsamını değerlendirsin.
            </p>

            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 px-8 py-5 bg-gold hover:bg-gold-dark text-navy-dark font-bold text-lg rounded-md transition-colors mb-6"
            >
              <i className="ri-whatsapp-line text-2xl"></i>
              VİDEOMU GÖNDERİP TEKLİF ALMAK İSTİYORUM
            </a>

            <p className="text-gold-light font-semibold text-lg md:text-xl">
              0507 708 91 98
            </p>
          </div>

          <div className="flex justify-center">
            <img
              src="https://readdy.ai/api/search-image?query=Hand%20holding%20modern%20smartphone%20recording%20video%20of%20luxury%20modern%20living%20room%20interior%2C%20bright%20natural%20light%20from%20large%20windows%2C%20minimal%20UI%20on%20phone%20screen%2C%20warm%20neutral%20tones%2C%20editorial%20product%20photography%2C%20clean%20premium%20aesthetic%2C%20soft%20shadows&width=600&height=700&seq=conversion-phone&orientation=portrait"
              alt="WhatsApp'tan video göndererek teklif alın"
              className="w-full max-w-md h-auto rounded-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}